import { useQuery } from '@tanstack/react-query';
import http from 'services/http';
import { useAuthContext } from 'modules/auth/context';
import { IS_IO } from 'lib/site';

export interface UnlockedAnalysis {
  attemptId: string;
  testTitle: string;
  standard?: 'IELTS' | 'SAT';
  unlockedAt: string;
}

export interface UnlockHistory {
  /** Credits spent since the first of this month. */
  usedThisMonth: number;
  items: UnlockedAnalysis[];
}

export async function getUnlockHistory(signal?: AbortSignal): Promise<UnlockHistory> {
  const { data } = await http.request.get<{ data: Partial<UnlockHistory> }>('/api/exam-insights/unlocks', { signal });
  return {
    usedThisMonth: data?.data?.usedThisMonth ?? 0,
    items: Array.isArray(data?.data?.items) ? data.data.items : [],
  };
}

/** The learner's own unlocked analyses, newest first. Learner plans are examing.uz only. */
export function useUnlockHistory() {
  const { state } = useAuthContext();
  return useQuery({
    queryKey: ['exam-insight-unlocks', state.user?.id],
    queryFn: ({ signal }) => getUnlockHistory(signal),
    enabled: Boolean(state.user?.id) && !IS_IO,
  });
}
